const WASH_SELECTOR = ".background-wash--treatments1.background-wash--bleed-container";
const TARGET_CLASS = "background-wash-reveal-target";
const PENDING_CLASS = "background-wash-reveal-target--pending";
const VISIBLE_CLASS = "background-wash-reveal-target--visible";
const TEXT_SELECTOR = [
	".page-heading__eyebrow",
	".page-heading__title",
	".page-heading__cta",
	".page-heading__text",
	".hero-centered-eyebrow",
	".hero-centered-heading",
	".hero-centered-intro",
	".hero-centered-actions",
].join(",");
const IMAGE_SELECTOR = [
	"figure",
	"picture",
	".image-tile",
	".hero-centered-decor",
	".hero-centered-smile",
].join(",");

function nextContentElement(element) {
	let sibling = element.nextElementSibling;

	while (sibling?.classList.contains("background-wash")) {
		sibling = sibling.nextElementSibling;
	}

	return sibling;
}

function uniqueElements(elements) {
	return elements.filter(
		(element, index) => elements.findIndex((item) => item === element) === index,
	);
}

function getRevealItems(target) {
	const textItems = [...target.querySelectorAll(TEXT_SELECTOR)];
	const imageItems = [...target.querySelectorAll(IMAGE_SELECTOR)].filter(
		(item) => !textItems.some((textItem) => textItem.contains(item)),
	);

	return uniqueElements([...textItems, ...imageItems]);
}

function prepareRevealItems(target) {
	const items = getRevealItems(target);

	items.forEach((item, index) => {
		item.classList.add("background-wash-reveal-item");
		item.style.setProperty("--background-wash-reveal-delay", `${180 + index * 140}ms`);
	});
}

export function initBackgroundWashReveals() {
	const targets = [...document.querySelectorAll(WASH_SELECTOR)]
		.map(nextContentElement)
		.filter(Boolean);

	if (!targets.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		for (const target of targets) {
			target.classList.add(TARGET_CLASS, VISIBLE_CLASS);
			prepareRevealItems(target);
		}

		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					continue;
				}

				entry.target.classList.add(VISIBLE_CLASS);
				observer.unobserve(entry.target);
			}
		},
		{
			threshold: 0.2,
		},
	);

	for (const target of targets) {
		target.classList.add(TARGET_CLASS, PENDING_CLASS);
		prepareRevealItems(target);
		observer.observe(target);
	}
}
